"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VisuallyHidden = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _VisuallyHiddenMixin = require("../../mixins/components/VisuallyHiddenMixin");
/**
 * The visually hidden block is most likely to be used to support accessibility cases. For instance,
 * two visually conjoined inputs may need two separate labels for screen readers.
 * A simple `display: none` or `visibility: hidden` would result in the screen reader not picking
 * up the content of the element.
 *
 * @since 6.13.0
 */
var VisuallyHidden = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "VisuallyHidden",
  componentId: "c11n-8-109-1__sc-t8tewe-0"
})(["", ""], _VisuallyHiddenMixin.VisuallyHiddenMixin);
exports.VisuallyHidden = VisuallyHidden;
VisuallyHidden.displayName = 'VisuallyHidden';

/** @component */